"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialsCard = void 0;
const React = require("react");
const material_ui_1 = require("material-ui");
const core_1 = require("@material-ui/core");
const claim_1 = require("shared/claim");
const router_1 = require("client/components/router");
const formatUsd_1 = require("shared/util/formatUsd");
const store_1 = require("client/modules/reporting/store");
const styles = core_1.createStyles({
    bgDefault: {
        backgroundColor: "#192e5b"
    },
    cardContainer: {
        display: "flex",
        height: "150px",
        position: "relative"
    },
    cardContent: {
        padding: "1rem"
    },
    cursor: {
        cursor: "pointer"
    },
    icon: {
        "& svg": {
            fill: "#d7d8d80d",
            height: "150px",
            width: "150px"
        },
        "alignItems": "center",
        "display": "flex",
        "justifyContent": "flex-end",
        "position": "absolute",
        "right": "20px",
        "top": "20px",
        "width": "100%"
    },
    moreInfo: {
        color: "#fff",
        cursor: "pointer"
    },
    moreInfoContainer: {
        "&:hover": {
            background: "#00000030"
        },
        "background": "#00000015",
        "padding": ".5rem"
    },
    root: {
        borderRadius: ".7rem",
        position: "relative"
    }
});
const decorate = core_1.withStyles(styles);
class FinancialsCardUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.onClick = async (e) => {
            const { onClick, query, to } = this.props;
            if (to && query) {
                store_1.reportsStore.editModal = false;
                store_1.reportsStore.showLoader = true;
                router_1.RouteManager.transitionTo(to);
                if (query.status && query.status === claim_1.ClaimStatus.Dispensed) {
                    await store_1.reportsStore.loadClaimAnalytics(query.siteId, query.status, query.startDate, query.endDate);
                }
                else {
                    await store_1.reportsStore.loadOrderAnalytics("", "", query.startDate, query.endDate, query.siteId, false);
                }
            }
            onClick && onClick(e);
        };
        this.onMouseEnter = (e) => {
            this.props.onMouseEnter && this.props.onMouseEnter(e);
        };
    }
    render() {
        const { title = "Default Title", data = 0, bgColor = this.props.classes.bgDefault, fontColor, icon } = this.props;
        return (React.createElement(material_ui_1.Card, { className: `${bgColor} ${this.props.classes.root} ${this.props.to ? this.props.classes.cursor : ""}`, onClick: this.onClick, onMouseEnter: this.onMouseEnter },
            React.createElement("div", { className: this.props.classes.cardContainer },
                React.createElement("div", { className: this.props.classes.cardContent },
                    React.createElement(material_ui_1.Typography, { className: `${fontColor ? fontColor : ""}`, variant: "display2", gutterBottom: true }, formatUsd_1.formatUsd(data)),
                    React.createElement(material_ui_1.Typography, { className: `${fontColor ? fontColor : ""}`, variant: "title", gutterBottom: true }, title)),
                icon ? React.createElement("div", { className: this.props.classes.icon }, icon) : null)));
    }
}
exports.FinancialsCard = decorate(FinancialsCardUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/financial/modules/financials-view/components/financials-card/financials-card.tsx
// module id = 3449
// module chunks = 0